import { FormWrapperProps } from '@shared/types/components/form/form-wrapper.types';

export const FormWrapper = ({ className, children, onSubmit, disabled }: FormWrapperProps) => {
  return (
    <form
      className={className}
      onSubmit={(event) => {
        event.preventDefault();
        if (!disabled) onSubmit?.(event);
      }}
    >
      {children}
      <button className="hidden" type="submit" />
    </form>
  );
};
